import React, { useState, useEffect } from "react";

const CircularCountdownTimer = ({ timeInSeconds, onTimeIsUp, visible }) => {
  const [remainingTime, setRemainingTime] = useState(timeInSeconds); // Start at n-1
  const [isCompleted, setIsCompleted] = useState(false);
  const radius = 100;
  const circumference = 2 * Math.PI * radius;

  // Effect to manage timer countdown
  useEffect(() => {
    if (!visible) {
      // Stop any ongoing interval when visibility changes to false
      setRemainingTime(-1);
      return;
    }

    setRemainingTime(timeInSeconds); // Reset to n-1 when timeInSeconds changes
    setIsCompleted(false); // Reset completed state

    if (timeInSeconds > 0) {
      const timer = setInterval(() => {
        setRemainingTime((prev) => {
          if (prev > 1) {
            return prev - 1;
          } else if (prev === 1) {
            clearInterval(timer);
            setIsCompleted(true); // Indicate completion visually
            setTimeout(() => {
              onTimeIsUp(); // Fire event after showing the full ring
              setRemainingTime(-1); // Stop further updates
            }, 1000); // Delay of 1 second before firing the event
            return 0;
          }
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [timeInSeconds, onTimeIsUp, visible]);

  const strokeDashoffset = isCompleted
    ? 0 // Show full ring when completed
    : (remainingTime / timeInSeconds) * circumference;

  if (!visible) return null; // Immediately hide the timer when visible is false

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <svg width="220" height="220">
        <circle
          cx="110"
          cy="110"
          r={radius}
          stroke="gray"
          strokeWidth="10"
          fill="transparent"
        />
        <circle
          cx="110"
          cy="110"
          r={radius}
          stroke="blue"
          strokeWidth="10"
          fill="transparent"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          transform="rotate(-90 110 110)" // Start at the top
        />
      </svg>
      <div style={{ position: "absolute", fontSize: "2em" }}>
        {remainingTime >= 0 ? remainingTime : 0}
      </div>
    </div>
  );
};

export default CircularCountdownTimer;
